// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Breadcrumb from './breadcrumb';

const buildRoutePath = route => route.path.endsWith('/') ? route.path : `${route.path}/`;

const getParam = (routePath, params) => params[routePath.match(/(:)(\w+)/)[2]];

const replaceParams = (routePath, param) => routePath.replace(/:\w+/, () => param);

const trimParam = (route, param) => {

    const routesToTrim = [
        'PIP_CODE_REQUEST',
        'PIP_DETAILS',
        'REGISTER'
    ];

    return routesToTrim.includes(route.name) ? param.split('-')[0] : param;

};

const Breadcrumbs = props => {

    let url;

    url = '';

    const breadcrumbs = props.routes.filter(route => route.path)
        .map((route, index, array) => {

            const last = (index === (array.length - 1));
            const routePath = buildRoutePath(route);

            if (routePath.includes(':')) {

                let param;

                param = getParam(routePath, props.params);

                url += replaceParams(routePath, param);

                param = trimParam(route, param);

                return (
                    <Breadcrumb
                        key={url}
                        last={last}
                        queryParams={props.location.search}
                        route={route}
                        shouldFormat={false}
                        text={param}
                        url={url}
                    />
                );

            }

            url += routePath;

            return (
                <Breadcrumb
                    key={url}
                    last={last}
                    queryParams={props.location.search}
                    route={route}
                    shouldFormat={true}
                    text={route.name}
                    url={url}
                />
            );

        });

    return (
        <nav className='bread-crumbs'>
            {breadcrumbs}
        </nav>
    );

};

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
    location: PropTypes.object.isRequired,
    params: PropTypes.object,
    routes: PropTypes.array.isRequired
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/app/breadcrumbs.js